export default {
  "hierarchy": {
    "inputTitle": [
      "label-inputTitle"
    ],
    "checkboxTitle": [
      "label-inputTitle",
      "label-checkboxTitle"
    ],
    "inputCaption": [
      "label-inputCaption"
    ],
    "input": [
      "label-input"
    ],
    "touchToolbarLabel": [
      "label-touchToolbarLabel"
    ],
    "checkboxLabel": [
      "label-checkboxLabel"
    ],
    "mobileUserNavBarNested": [
      "label-mobileUserNavBarNested"
    ],
    "checkboxLabelWrap": [
      "label-checkboxLabelWrap"
    ],
    "subtitle": [
      "label-subtitle"
    ],
    "captionSmallBold": [
      "label-captionSmallBold"
    ],
    "captionSmall": [
      "label-captionSmall"
    ],
    "helperText": [
      "label-inputCaption",
      "label-helperText"
    ],
    "caption": [
      "label-caption"
    ],
    "control": [
      "label-inputTitle",
      "label-control"
    ],
    "large": [
      "label-large"
    ],
    "propGrid": [
      "label-propGrid"
    ],
    "loginHeader": [
      "label-loginHeader"
    ]
  },
  "props": {
    "default": {},
    "inputTitle": {},
    "checkboxTitle": {},
    "inputCaption": {},
    "input": {},
    "touchToolbarLabel": {},
    "checkboxLabel": {},
    "mobileUserNavBarNested": {},
    "checkboxLabelWrap": {},
    "subtitle": {},
    "captionSmallBold": {},
    "captionSmall": {},
    "helperText": {},
    "caption": {},
    "control": {},
    "large": {},
    "propGrid": {},
    "loginHeader": {}
  }
}